import Measure from 'react-measure';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import styles from './ScrollableList.module.scss';

import {VariableSizeList as List} from 'react-window';

const DEFAULT_ITEM_HEIGHT = 50;
const savedPositions = {},
    savedHeights = {};

const ScrollableList = props => {
    const {className = '', children, savePosition = location.pathname} = props,
        items = React.Children.toArray(children),
        [[listWidth, listHeight], setListSize] = useState([]),
        [heights] = useState(savePosition ? savedHeights[savePosition] || (savedHeights[savePosition] = {}) : {}),
        [initialScrollOffset] = useState(savePosition ? savedPositions[savePosition] || 0 : 0),
        listRef = useRef();

    useEffect(() => {
        if (initialScrollOffset) {
            // console.log('Autoscroll to ', initialScrollOffset);
            listRef.current.scrollTo(initialScrollOffset);
        }
    }, [listRef]);

    useEffect(() => {
        listRef.current?.resetAfterIndex(0);
    }, [items]);

    const renderItem = useCallback(
        ({index, style, data: items}) => {
            const item = items[index];
            return (
                <div style={style} /*onLoad={measure}*/>
                    <Measure
                        bounds
                        onResize={contentRect => {
                            const height = contentRect.bounds.height;
                            if (height != heights[item.key]) {
                                // console.log('Update item ', item.key, 'height to ', height);
                                heights[item.key] = height;
                                listRef.current?.resetAfterIndex(index);
                            }
                        }}>
                        {({measureRef}) => <div ref={measureRef}>{items[index]}</div>}
                    </Measure>
                </div>
            );
        },
        [listRef]
    );

    const handleScroll = useCallback(
        ({scrollOffset}) => {
            if (savePosition) {
                savedPositions[savePosition] = scrollOffset;
            }
        },
        [savePosition]
    );

    const getItemSize = useCallback(
        index => {
            const item = items[index];
            return heights[item.key] || DEFAULT_ITEM_HEIGHT;
        },
        [items]
    );

    const getItemKey = useCallback((index, data) => data[index].key || index, []);

    return (
        <div className={[styles.ScrollableList, 'fill-container', className].join(' ')}>
            <Measure
                bounds
                onResize={contentRect => {
                    const {width, height} = contentRect.bounds;
                    if (listWidth != width || listHeight != height) {
                        setListSize([width, height]);
                    }
                }}>
                {({measureRef}) => (
                    <div ref={measureRef}>
                        <List
                            ref={listRef}
                            height={listHeight || 0}
                            itemCount={listRef.current ? items.length : 0}
                            itemKey={getItemKey}
                            itemSize={getItemSize}
                            itemData={items}
                            estimatedItemSize={DEFAULT_ITEM_HEIGHT}
                            width={listWidth || 0}
                            onScroll={handleScroll}>
                            {renderItem}
                        </List>
                    </div>
                )}
            </Measure>
        </div>
    );
};

export default ScrollableList;
